import React, {useEffect, useState} from 'react'
import Loader from "../../../Loader/Loader";
import Header from "../../layout/header";
import BottomMenu from "../../layout/bottomMenu";
import SuccessModal from "../../CustomModal/Success";
import FailedModal from "../../CustomModal/Failed";
import FileUpload from "../../FileUploads/FileUpload";
import useLatLng from "../../../hooks/uselatlng/uselatlng";
import {toast} from "react-toastify";
import DashboardMenu from "../../layout/dashboardMenu";

const ActivityCreate = ({
                            getActivity,
                            leadActivity=[],
                            getActivityById,
                            leadActivityById=[],
                            documentUploadUrlPublic,
                            documentUrlDataPublic,
                            match,
                            saveActivity,
                            saveLeadActivity=[],
                            history,
                            cancelActivity,
                            cancelActivityDetails=[],
                        }) => {

    const islatlng = useLatLng();
    const [isLoading, setIsLoading] = useState(false)
    const [isSuccessModalOpen, setIsSuccessModalOpen] = React.useState(false);
    const [isFailedModalOpen, setIsFailedModalOpen] = React.useState(false);
    const [countToOpenModal, setCountToOpenModal] = useState(0)
    const [isFirstActivityCreated, setIsFirstActivityCreated] = useState(false)
    const [isAllow, setIsAllow] = useState(false);
    const [activityId, setActivityId] = useState('')
    const [remarks, setRemarks] = useState('')
    const [msg, setMsg] = useState('')
    const [inputList, setInputList] = useState([{
        activity_type_id: '',
        activity_date: '',
        meta_data: {},
        lat:'',
        long:'',
        next_activity_type_id: '',
        next_activity_date: '',
        description:''
    }])
    const [mapLocation, setMapLocation] = useState({
        address: 'Delhi',
        lat: 0,
        lng: 0,
    });

    useEffect(() => {
        if (islatlng === false) {
            setIsAllow(true);
        } else {
            setIsAllow(false);
        }
        var lati = Number(islatlng?.lat);
        var langi = Number(islatlng?.lng);
        if (!isNaN(lati) && !isNaN(langi)) {
            setMapLocation({
                address: 'Delhi6',
                lat: Number(islatlng?.lat),
                lng: Number(islatlng?.lng),
            });
        }
    }, [islatlng]);

    useEffect(() => {
        (async () => {
            setIsLoading(true)
            await getActivity()
            await getActivityById(match?.params?.id)
            setIsLoading(false)
        })()
    }, [])

    useEffect(() => {

        if(leadActivityById && leadActivityById?.data !== undefined && leadActivityById?.data?.id !== undefined){
            setIsFirstActivityCreated(true)
            setActivityId(leadActivityById?.data?.id)
        }
    }, [leadActivityById])

    const handleInput = (key, val, metaKey ,e) => {
        let list = [...inputList]
        if (key === 'meta_data') {
            inputList[0][key][metaKey] = val
        } else {
            inputList[0][key] = val
        }
        setInputList(list)
    }

    useEffect(() => {
        setIsFailedModalOpen(false)
        setIsSuccessModalOpen(false)
        if (saveLeadActivity?.status === 200) {
            setIsSuccessModalOpen(true)
            setMsg(saveLeadActivity?.message)
        } else if (saveLeadActivity?.status !== undefined && saveLeadActivity?.status !== 200) {
            setCountToOpenModal(countToOpenModal + 1)
            setMsg(saveLeadActivity?.message)
            setIsFailedModalOpen(true)
        }
    }, [saveLeadActivity])

    useEffect(() => {
        setIsFailedModalOpen(false)
        setIsSuccessModalOpen(false)
        if (cancelActivityDetails?.status === 200) {
            setIsSuccessModalOpen(true)
            setMsg(cancelActivityDetails?.message)
        } else if (cancelActivityDetails?.status !== undefined && saveLeadActivity?.status !== 200) {
            setCountToOpenModal(countToOpenModal + 1)
            setMsg(cancelActivityDetails?.message)
            setIsFailedModalOpen(true)
        }
    }, [cancelActivityDetails])

    const handleSubmit = async (e) => {
        e.preventDefault()
        let list = inputList[0]
        if(remarks !== '') {
            list['activity_type_id'] = leadActivityById?.data?.activity_type_id
            list['activity_date'] = leadActivityById?.data?.activity_date
        }
        if(list['activity_type_id'] === '' && list['next_activity_type_id'] === ''){
            toast.error("Please choose activity type or next activity type is required")
            return false
        }

        if(list['activity_type_id'] !== '' && list['activity_date'] === ''){
            toast.error("Please choose activity date")
            return false
        }

        if(list['next_activity_type_id'] !== '' && list['next_activity_date'] === ''){
            toast.error("Please choose next activity date")
            return false
        }
        list['id'] = match?.params?.id
        list['lat'] = islatlng?.lat
        list['long'] = islatlng?.lng

        if(list['long'] == null || list['lat'] == null){
            toast.error('Please enable your location');
            return false
        }

        list['model_id'] = match?.params?.lead_id
        list['model_type'] = 'leads'
        setIsLoading(true)
        await saveActivity(list)
        setIsLoading(false)
    }

    const handleCancel = async (e) => {
        e.preventDefault()
        if(islatlng?.lat == null || islatlng?.lng == null){
            toast.error('Please enable your location');
            return false
        }
        setIsLoading(true)
        await cancelActivity({id:match?.params?.id, lat:islatlng?.lat, long:islatlng?.lng})
        setIsLoading(false)
    }

    return (
        <>
            <SuccessModal
                isOpen={isSuccessModalOpen}
                msg={msg}
                url={`lead-activity-list/${match?.params?.lead_id}`}
            />


            <FailedModal
                isOpen={isFailedModalOpen}
                msg={msg}
                countToOpenModal={countToOpenModal}
            />
            <Loader isLoading={isLoading}/>
            <div id="wrapper">
                <DashboardMenu/>
                <div id="content-wrapper" className="d-flex flex-column">
                    <div id="content">
                        <Header
                            title={"Activity"}
                            history={history}
                        />
                        {/*BODY*/}
                        <div className="container-fluid common-bg">
                            <form onSubmit={(e) => handleSubmit(e)}>
                                <div className="row">
                                    <div className="col-md-12">
                                        {leadActivityById?.data?.status === 1 &&
                                            <>
                                                <div
                                                    className="d-sm-flex align-items-center justify-content-between com-sub-heading">
                                                    <h1 className="h3 mb-0 text-black-100"><b>{leadActivityById?.data?.activity_name}</b></h1>
                                                </div>
                                                <div className="card-body bg-white">
                                                    <div className="user">
                                                        <div className="form-group row">
                                                            <div className="col-sm-6 mtk-075 float-field mb-4">
                                                            <textarea
                                                                className="form-control form-control-user cus-red"
                                                                placeholder=" Remarks*"
                                                                onChange={(e) => {
                                                                    handleInput('meta_data', e.target.value, 'remark' ,e)
                                                                    setRemarks(e.target.value)
                                                                }}
                                                                id="validationCustom01"
                                                                rows="4" cols="50"
                                                            />
                                                                <label className="large-label float-lb">
                                                                    {/*Description*/}
                                                                </label>
                                                            </div>
                                                            <div className="col-sm-6 mtk-1 float-field mb-3">
                                                                <FileUpload
                                                                    id={"addAttachment"}
                                                                    accept=".png,.jpg,.jpeg"
                                                                    documentUploadUrl={documentUploadUrlPublic}
                                                                    documentUrlData={documentUrlDataPublic}
                                                                    onChange={(e, val) => {
                                                                        handleInput('meta_data', e, 'Document',e)
                                                                    }}
                                                                    prefilledFilename={""}
                                                                    multiple={true}
                                                                >
                                                                    File Attachment
                                                                </FileUpload>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </>
                                        }
                                        <div
                                            className="d-sm-flex align-items-center justify-content-between com-sub-heading">
                                            <h1 className="h3 mb-0 text-black-100"><b>Schedule Future Activity</b></h1>
                                        </div>
                                        <div className="card-body bg-white">
                                            <div className="user">
                                                <div className="form-group row">
                                                    <div className="col-sm-6 mt-1 float-field" style={{marginTop:"16px !important"}}>
                                                        <select
                                                            className="form-control form-control-user"
                                                            onChange={(e) => {
                                                                handleInput('next_activity_type_id', e.target.value, e)
                                                            }} >
                                                            <option value="">Select Activity</option>
                                                            {leadActivity && leadActivity?.data !== undefined  && leadActivity?.data.map((val) => {
                                                                return (
                                                                    <option
                                                                        value={val?.id}>{val.name}</option>
                                                                )
                                                            })}
                                                        </select>
                                                        <label className="large-label float-lb">
                                                            Activity
                                                        </label>
                                                    </div>
                                                    <div className="col-sm-6 mtk-075 float-field">
                                                        <input type="date"
                                                               className="form-control form-control-user"
                                                               placeholder=" "
                                                               onChange={(e) => {
                                                                   handleInput('next_activity_date', e.target.value, e)
                                                               }}
                                                               id="validationCustom01"
                                                        />
                                                        <label className="large-label float-lb">
                                                            Date
                                                        </label>
                                                    </div>
                                                    <div className="col-sm-6 mtk-075 float-field mb-4">
                                                            <textarea
                                                                className="form-control form-control-user"
                                                                placeholder=" Description"
                                                                onChange={(e) => {
                                                                    handleInput('description', e.target.value, '' ,e)
                                                                }}
                                                                id="validationCustom01"
                                                                rows="4" cols="50"
                                                            />
                                                        <label className="large-label float-lb">
                                                            {/*Description*/}
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-12 mt-4">
                                    <button className="btn btn-primary btn-user btn-block submit-btn">
                                        Submit
                                    </button>
                                </div>
                            </form>
                            <div className="col-md-12 mt-4">
                                <button className="btn btn-primary btn-user btn-block submit-btn cancel-activity" onClick={(e) => handleCancel(e)}>
                                    Close
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <BottomMenu/>
            </div>
        </>
    )
}

export default ActivityCreate